// Feature markers (ARCHITECTURE §4.6). Core declares what every page
// contains; templates decide how it looks. A marker is a plain attribute on an
// element that already exists, so it changes no pixels and no text:
//
//   <section {...sf('player.game-log')}>…</section>
//   <button {...sf('player.stats.scope', 'season')} onClick={…}>Season</button>
//
// The contract test asserts every feature whose `when(vm)` holds is marked,
// and that no unknown ids appear. Markers double as e2e selectors.

/** Dotted, kebab-case segments: 'player.game-log', 'site.footer.powered-by', 'home.section.upcoming'. */
export type FeatureId = string

export const FEATURE_ID_PATTERN = /^[a-z][a-z0-9-]*(?:\.[a-z0-9][a-z0-9-_]*)+$/

export interface SfAttrs {
  'data-sf': FeatureId
  'data-sf-value'?: string
}

export function sf(id: FeatureId, value?: string): SfAttrs {
  return value === undefined ? { 'data-sf': id } : { 'data-sf': id, 'data-sf-value': value }
}

/** Feature ids every page may emit regardless of its own registry entry. */
export const GLOBAL_FEATURE_IDS: readonly FeatureId[] = [
  'site.header',
  'site.footer',
  'site.footer.powered-by',
  'site.footer.language',
  'site.nav.sport-switcher',
  // The header account control (SiteNav.account): the sign-in link or the
  // signed-in menu trigger. Only with the registration add-on.
  'site.nav.account',
  'state.loading',
  'state.not-found',
  'state.error',
]
